"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.USE_CLASSES = exports.INPUT_SIZE_OPTIONS = void 0;
var INPUT_SIZE_OPTIONS = {
  default: '',
  small: 'private-form__control--small'
};
exports.INPUT_SIZE_OPTIONS = INPUT_SIZE_OPTIONS;
var USE_CLASSES = {
  default: '',
  'on-dark': 'private-form__control--on-dark'
};
exports.USE_CLASSES = USE_CLASSES;